import React, { useState } from 'react';

const RSVPModal = ({ isOpen, onClose }) => {
  const [currentGuest, setCurrentGuest] = useState({
    nome: '',
    cognome: '',
    isBambino: false,
    allergie: ''
  });
  const [guestsList, setGuestsList] = useState([]);
  const [status, setStatus] = useState('idle'); // idle, submitting, success, error

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCurrentGuest(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const addGuest = (e) => {
    e.preventDefault();
    if (!currentGuest.nome || !currentGuest.cognome) return;

    setGuestsList([...guestsList, currentGuest]);
    setCurrentGuest({
      nome: '',
      cognome: '',
      isBambino: false,
      allergie: ''
    });
  };

  const removeGuest = (index) => {
    const newList = [...guestsList];
    newList.splice(index, 1);
    setGuestsList(newList);
  };

  const handleSubmitAll = async () => {
    // Se c'è ancora qualcuno nel form non aggiunto alla lista, lo aggiungiamo se i campi sono pieni
    let finalList = [...guestsList];
    if (currentGuest.nome && currentGuest.cognome) {
      finalList.push(currentGuest);
    }

    if (finalList.length === 0) {
      alert("Inserisci almeno un partecipante!");
      return;
    }

    setStatus('submitting');

    try {
      const response = await fetch('/api/guests', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(finalList),
      });

      if (response.ok) {
        setStatus('success');
        setTimeout(() => {
          onClose();
          setGuestsList([]);
          setCurrentGuest({ nome: '', cognome: '', isBambino: false, allergie: '' });
          setStatus('idle');
        }, 2000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error("Errore:", error);
      setStatus('error');
    }
  };

  return (
    <div className="modal-overlay">
      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          backdrop-filter: blur(5px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          padding: 20px;
        }

        .modal-content {
          background: #ffffff;
          width: 100%;
          max-width: 500px;
          border-radius: 12px;
          box-shadow: 0 20px 50px rgba(0,0,0,0.2);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          max-height: 90vh;
          font-family: 'Josefin Sans', sans-serif;
        }

        .modal-header {
          padding: 20px 25px;
          background: #c3e5ea;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .modal-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 24px;
          color: #3a4a5c;
          margin: 0;
        }

        .close-btn {
          background: none;
          border: none;
          font-size: 28px;
          color: #3a4a5c;
          cursor: pointer;
          line-height: 1;
        }

        .modal-body {
          padding: 25px;
          overflow-y: auto;
        }

        .form-group {
          margin-bottom: 15px;
        }

        .form-label {
          display: block;
          font-size: 14px;
          color: #5a6a7c;
          margin-bottom: 5px;
          font-weight: 300;
        }

        .form-input {
          width: 100%;
          padding: 10px;
          border: 1px solid #c3e5ea;
          border-radius: 4px;
          font-family: 'Josefin Sans', sans-serif;
          font-size: 16px;
        }

        .form-input:focus {
          outline: none;
          border-color: #8ac4d0;
          box-shadow: 0 0 0 2px rgba(195, 229, 234, 0.4);
        }

        .checkbox-group {
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 20px 0;
        }

        .checkbox-group input {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }

        .add-btn {
          width: 100%;
          padding: 12px;
          background: #ffffff;
          border: 1px dashed #8ac4d0;
          color: #8ac4d0;
          font-family: 'Josefin Sans', sans-serif;
          text-transform: uppercase;
          letter-spacing: 2px;
          cursor: pointer;
          margin-top: 10px;
          transition: all 0.3s;
        }

        .add-btn:hover {
          background: #fdfcfb;
          border-color: #5a6a7c;
          color: #5a6a7c;
        }

        .guest-list {
          margin-top: 25px;
          border-top: 1px solid #e8ebe6;
          padding-top: 15px;
        }

        .guest-list-title {
          font-size: 14px;
          color: #8ac4d0;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 10px;
        }

        .guest-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #fdfcfb;
          padding: 10px;
          border-radius: 4px;
          margin-bottom: 8px;
          border-left: 3px solid #f6cdca;
        }

        .guest-info {
          font-size: 14px;
          color: #3a4a5c;
        }

        .guest-tags {
          font-size: 11px;
          color: #888;
          font-style: italic;
        }

        .remove-guest {
          color: #ff6b6b;
          background: none;
          border: none;
          cursor: pointer;
          font-size: 18px;
        }

        .submit-section {
          padding: 20px 25px;
          border-top: 1px solid #e8ebe6;
          background: #fdfcfb;
        }

        .submit-btn {
          width: 100%;
          padding: 15px;
          background: #8ac4d0;
          color: white;
          border: none;
          font-family: 'Josefin Sans', sans-serif;
          text-transform: uppercase;
          letter-spacing: 3px;
          cursor: pointer;
          transition: background 0.3s;
        }

        .submit-btn:hover {
          background: #7ab9c7;
        }

        .success-message {
          text-align: center;
          padding: 40px;
          color: #3a4a5c;
        }

        .success-icon {
          font-size: 48px;
          color: #8ac4d0;
          margin-bottom: 20px;
          display: block;
        }
      `}</style>

      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">Conferma Partecipazione</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        {status === 'success' ? (
          <div className="success-message">
            <span className="success-icon">♥</span>
            <h3>Grazie!</h3>
            <p>La vostra presenza è il regalo più bello.</p>
          </div>
        ) : (
          <>
            <div className="modal-body">
              <form onSubmit={addGuest}>
                <div className="form-group">
                  <label className="form-label">Nome</label>
                  <input
                    type="text"
                    name="nome"
                    className="form-input"
                    value={currentGuest.nome}
                    onChange={handleInputChange}
                    placeholder="Nome dell'invitato"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Cognome</label>
                  <input
                    type="text"
                    name="cognome"
                    className="form-input"
                    value={currentGuest.cognome}
                    onChange={handleInputChange}
                    placeholder="Cognome dell'invitato"
                  />
                </div>
                <div className="checkbox-group">
                  <input
                    type="checkbox"
                    name="isBambino"
                    id="isBambino"
                    checked={currentGuest.isBambino}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="isBambino" style={{color: '#5a6a7c'}}>È un bambino/a?</label>
                </div>
                <div className="form-group">
                  <label className="form-label">Allergie o Intolleranze</label>
                  <input
                    type="text"
                    name="allergie"
                    className="form-input"
                    value={currentGuest.allergie}
                    onChange={handleInputChange}
                    placeholder="Es. Celiachia, Noci..."
                  />
                </div>

                <button className="add-btn" type="submit">
                  + Aggiungi altro partecipante
                </button>
              </form>

              {guestsList.length > 0 && (
                <div className="guest-list">
                  <h4 className="guest-list-title">Partecipanti da inserire ({guestsList.length})</h4>
                  {guestsList.map((g, idx) => (
                    <div key={idx} className="guest-item">
                      <div>
                        <div className="guest-info">{g.nome} {g.cognome}</div>
                        <div className="guest-tags">
                          {g.isBambino ? 'Bambino • ' : ''}
                          {g.allergie ? `Allergie: ${g.allergie}` : ''}
                        </div>
                      </div>
                      <button className="remove-guest" onClick={() => removeGuest(idx)}>&times;</button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="submit-section">
              <button className="submit-btn" onClick={handleSubmitAll} disabled={status === 'submitting'}>
                {status === 'submitting' ? 'Invio in corso...' : 'Conferma Tutto'}
              </button>
              {status === 'error' && <p style={{color: 'red', textAlign: 'center', marginTop: '10px'}}>Errore nell'invio. Riprova.</p>}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RSVPModal;
